"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccAudiencePickerAudienceSelectorsButtonsStyle = (0, _react.useMemo)(function () {
    var ccAudiencePickerAudienceSelectorsButtons = (0, _css.css)({
      display: 'flex',
      gap: pxToRem(10)
    });
    var ccAudiencePickerAudienceSelectorsButtonsCount = (0, _css.css)({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main
    });
    return {
      ccAudiencePickerAudienceSelectorsButtons: ccAudiencePickerAudienceSelectorsButtons,
      ccAudiencePickerAudienceSelectorsButtonsCount: ccAudiencePickerAudienceSelectorsButtonsCount
    };
  }, [pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-AudiencePicker__audience-selectors-buttons': ccAudiencePickerAudienceSelectorsButtonsStyle.ccAudiencePickerAudienceSelectorsButtons,
    'cc-AudiencePicker__audience-selectors-buttons__count': ccAudiencePickerAudienceSelectorsButtonsStyle.ccAudiencePickerAudienceSelectorsButtonsCount
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;